import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "edit-police pt-0" }
const _hoisted_2 = { class: "row justify-content-center" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "edit-police__head" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "edit-police__head__title" }, [
    /*#__PURE__*/_createElementVNode("span", null, "Persistencia de clientes")
  ])
], -1)
const _hoisted_5 = {
  key: 0,
  class: "text-center text-main"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-circle-notch fa-spin d-block mb-1" }, null, -1)
const _hoisted_7 = {
  key: 1,
  class: "edit-police__body"
}
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-md-6" }
const _hoisted_10 = {
  key: 0,
  class: "card mb-3"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("b", null, "PERSISTENCIA DE CLIENTES")
], -1)
const _hoisted_12 = { class: "card-body" }
const _hoisted_13 = { class: "col-md-7" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        (_ctx.flags.searching)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _hoisted_6,
              _createTextVNode(" Cargando datos... ")
            ]))
          : _createCommentVNode("", true),
        (!_ctx.flags.searching)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  (_ctx.data)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _hoisted_11,
                        _createElementVNode("div", _hoisted_12, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.monthlyAverage, (item, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "row",
                              key: index
                            }, [
                              _createElementVNode("div", _hoisted_13, "Mes " + _toDisplayString(index + 1) + ":      " + _toDisplayString(item) + "%", 1)
                            ]))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}